export default __webpack_public_path__ + "static/media/portatambor_verde2.cf197118.png";